import React, { useState, useContext } from "react";
import ActionsContext from "common/ActionsContext";
import Modal from "common/Modal";
import styled from "styled-components";

const Wrapper = styled.div`
  ul {
    columns: 3 auto;
  }
`;

const DPIPredfinedProfilesModal = () => {
  const [open, setOpen] = useState(false);
  const [errorFooter, setErrorFooter] = useState("");
  const actions = useContext(ActionsContext);
  actions.recv("update-predfined-profiles", function () {
    setOpen(true);
  });
  const doClose = () => setOpen(false);
  if (open !== true) {
    return null;
  }

  const handleApply = () => {
    ifCl
      .run("set profile predefined")
      .then((response) => {
        actions.send("do-load");
        setOpen(false);
      })
      .catch((error) => {
        setErrorFooter(`Error Create/Update Predfined Profiles: ${error}`);
      });
  };

  return (
    <Modal
      title="Create/Update Predefined Profiles"
      onClose={doClose}
      large={true}
      applyLabel="OK"
      onApply={handleApply}
      closeLabel="CANCEL"
      content={() => (
        <>
          <p>
            This will update (resetting their contents to the ones in this
            software release), or create if they do not exist, the
            teleconf-ip-ports internet profile and the following dpi profiles:{" "}
          </p>
          <Wrapper>
            {" "}
            <ul>
              <li>video</li>
              <li>sw-updates</li>
              <li>speed-tests</li>
              <li>teleconf-tcp</li>
              <li>video-youtube</li>
              <li>video-netflix</li>
              <li>video-facebook</li>
              <li>video-instagram</li>
              <li>video-amazon-prime</li>
              <li>video-hbo</li>
              <li>video-hulu</li>
              <li>video-disney+</li>
              <li>video-apple</li>
              <li>video-twitch</li>
              <li>video-paramount+</li>
              <li>video-tiktok</li>
              <li>video-magis-tv</li>
              <li>video-star+</li>
              <li>video-globo.com</li>
              <li>video-streaming-other</li>
              <li>twitter</li>
              <li>whatsapp</li>
              <li>sw-updates-microsoft</li>
              <li>sw-updates-apple</li>
              <li>sw-updates-android</li>
              <li>sw-updates-playstation</li>
              <li>sw-updates-xbox</li>
              <li>sw-updates-nintendo</li>
              <li>sw-updates-epic-games</li>
              <li>sw-updates-steam-games</li>
              <li>p2p-bittorrent</li>
              <li>speed-tests-ookla</li>
              <li>speed-tests-fast.com</li>
            </ul>
          </Wrapper>
        </>
      )}
      footerMessage={
        errorFooter !== "" ? (
          <span className="modal-err-msg color-red">
            <h5>{errorFooter}</h5>
          </span>
        ) : null
      }
    />
  );
};

export default DPIPredfinedProfilesModal;
